/* eslint-disable @typescript-eslint/no-explicit-any */
import { default as actionCreatorFactory } from 'typescript-fsa';
import {
  PageDataParams,
  SFFProblemType
} from 'its-pages';
import { InputContent } from '../../page-content/input-content';
// import { SelectContent } from '../../lib/content/select-content';
import { IntroContent } from '../../page-content/intro-content';
import { ConstructContent } from '../../page-content/construct-content';
import { SkillCompletionContent } from '../../page-content/skill-completion-content';
import { DiscourseContent } from '../../page-content/discourse-content';
import { EvalContent } from '../../page-content/eval-content';
import { ModuleCompletionContent } from '../../page-content/module-completion-content';
import { PageContent } from '../../page-content/page-content';
import { FixedOptionContent } from '../../page-content/fixed-option-content';

const actionCreator = actionCreatorFactory('content');

type Content = any;
export const contentLoaded = actionCreator<Content>('LOADED');

type PageContainerMap = {
  [type in SFFProblemType]: 
    typeof IntroContent|
    typeof InputContent| 
    typeof ConstructContent|
    typeof DiscourseContent|
    typeof EvalContent|
    typeof ModuleCompletionContent|
    typeof FixedOptionContent|
    typeof SkillCompletionContent|
    undefined
};

/**
 * NOTE: These are like the 'templates' to create the pages that the student sees. These represent the
 * individual questions and other info screens.
 */
const pageContainerMap: PageContainerMap= {
  [SFFProblemType.ModuleIntro]: IntroContent,
  [SFFProblemType.Type1]: InputContent,
  [SFFProblemType.Type2]: InputContent,
  [SFFProblemType.Type3]: InputContent,
  [SFFProblemType.Type4]: InputContent,
  [SFFProblemType.Type6]: ConstructContent,
  [SFFProblemType.Type7]: InputContent,
  [SFFProblemType.Discourse]: DiscourseContent,
  [SFFProblemType.DiscourseFixed]: DiscourseContent,
  [SFFProblemType.SelfEval]: EvalContent,
  [SFFProblemType.PeerEval]: EvalContent,
  [SFFProblemType.ModuleCompletion]: ModuleCompletionContent,
  [SFFProblemType.FixedOption]: FixedOptionContent,
  [SFFProblemType.SkillCompletion]: SkillCompletionContent,
  [SFFProblemType.TagAnnotation]: undefined,
  [SFFProblemType.AnnotateSingle]: undefined,
  [SFFProblemType.AnnotateMulti]: undefined,
  [SFFProblemType.Type5]: undefined,
}

/**
 * Use this factory function to get the 'constructor' that can be used to render the actual page question
 * or info screen pages. This is what is used for the student facing questions.
 * 
 * @param params 
 * @returns 
 */
export function pageContentFactory(
  params: PageDataParams
): PageContent | undefined {
  const type = params.rawPageData.type;

  const ContainerType = pageContainerMap[type];

  return ContainerType && new ContainerType(params);
}
